import { useTenant } from "@/context/TenantContext";
import { Anchor } from "lucide-react";

/**
 * Visible only on virtual-franchise / environment-isolated subdomains.
 * Format: [state].[sector].eigooinc.net
 */
export default function TenantBanner() {
    const { tenant } = useTenant();
    if (!tenant?.isolated) return null;

    return (
        <div
            className="bg-gold text-forest text-[0.65rem] tracking-[0.3em] uppercase py-2 text-center"
            data-testid="tenant-banner"
        >
            <span className="inline-flex items-center gap-2">
                <Anchor size={11} /> Island Gold Studio · {tenant.brand} ·{" "}
                {(tenant.state || "").toUpperCase()} ·{" "}
                {tenant.status || "isolated"}
            </span>
        </div>
    );
}
